import { useMutation, useQueryClient } from "react-query";
import { useRecoilState } from "recoil";
import { updateCodeLevel } from "../../../../../actions/Utilities/CodeLevel";
import { toast } from "../../../../../components/toastNotification";
import { editStateCodeLevel } from "../atoms/atoms";

const useUpdateCodeLevel = () => {
  const queryClient = useQueryClient();
  const [, setEditState] = useRecoilState(editStateCodeLevel);

  const { mutate } = useMutation(
    (CodeLevel) => updateCodeLevel({ ...CodeLevel }),
    {
      onSuccess: (res) => {
        if (res.data === "duplicate") {
          toast.fire(
            "Failed",
            "Another Code Level already has the same information",
            "error"
          );
        } else if (res.status === 201) {
          setEditState(false);
          queryClient.invalidateQueries("GetCodeLevels");
          toast.fire("Success", "Code Level updated successfully", "success");
        } else {
          toast.fire(
            "Failed",
            "Server Error: Cannot update Code Level",
            "error"
          );
        }
      },
      onError: (error) => {
        if (
          error.response.data.message === "Failed sending of email" ||
          error.response.data.message === "Failed inserting of notification"
        ) {
          toast.fire(
            "Success",
            "Code Level updated successfully, but " +
              error.response.data.message,
            "warning"
          );
          queryClient.invalidateQueries("GetCodeLevels");
        } else {
          toast.fire(
            "Failed",
            "Server Error: Cannot add new Code Level",
            "error"
          );
        }
      },
    }
  );
  return mutate;
};
export default useUpdateCodeLevel;
